import React from "react";
import { useObserver } from "mobx-react-lite";
import { useStore } from "../../../hooks/useStore";
import { useHistory } from "react-router-dom";
import { useFetch } from "../../../hooks/useFetch";
import { Card, Timeline, Row, Col, Descriptions } from 'antd';
import moment from "moment";
import { courierStatusColors } from "../../../constants/constants";
import { calculateDuration, minuteToString } from "../../../utils/helpers";

export const CourierShiftDetail = () => {
    const stores = useStore();
    const history = useHistory();

    const urlSearchParams = new URLSearchParams(history.location.search);
    const courierShiftQuery = urlSearchParams.get("q");

    const courierTckn = courierShiftQuery.split("/")[0]
    const [loading, courierData, setData, setLoading] = useFetch({
        defaultDataValue: false,
        fetchFn: stores.courierStore.getCourierByTckn.bind(null, {
            courierTckn
        }),
        dependencies: []
    });

    const [courierStatusDataLoading, courierStatusData, setCourierStatusData, setCourierStatusDataLoadingLoading] = useFetch({
        defaultDataValue: null,
        initialCall: false,
        fetchFn: stores.courierStore.getCourierStatusLogs.bind(null, {
            courierId: courierData._id,
            startDate: moment(courierShiftQuery.split("/")[1], "DD-MM-YYYY").subtract(2, 'days'),
            endDate: moment(courierShiftQuery.split("/")[1], "DD-MM-YYYY").add(2, 'days')
        }),
        dependencies: [courierData]
    });

    const [shiftsLoading, shifts, setShifts, setShiftsLoading] = useFetch({
        defaultDataValue: null,
        initialCall: false,
        fetchFn: stores.shiftStore.getShiftReportByCourierIdAndDate.bind(null, {
            courierId: courierData._id,
            date: moment(courierShiftQuery.split("/")[1], "DD-MM-YYYY").format('YYYY-MM-DD'),
        }),
        dependencies: [courierData]
    });

    const [courierReportsLoading, courierReports, setCourierReports, setCourierReportsLoading] = useFetch({
        defaultDataValue: null,
        initialCall: true,
        fetchFn: stores.shiftStore.getShiftReportByTcknAndDate.bind(null, {
            tckn: courierTckn,
            reportDate: moment(courierShiftQuery.split("/")[1], "DD-MM-YYYY").format('YYYY-MM-DD')
        }),
        dependencies: []
    });

    return useObserver(() => (
        <React.Fragment>
            <Row gutter={16}>
                <Col span={24} align="middle">
                    <Card title="Kurye Bilgileri" bordered={true}>
                        <p>Tarih : {courierShiftQuery.split("/")[1]}</p>
                        <p>Kurye Adı : {courierData.fullname}</p>
                        <p>Kurye Tckn : {courierData.tckn}</p>
                        <p>Kurye Id : {courierData._id}</p>
                    </Card>
                </Col>
                <Col span={24}>
                    <Card bordered={false}>
                        {courierReports !== null && courierReports.results.map((report, reportIndex) =>
                            <Descriptions
                                bordered
                                title={`${reportIndex + 1}. Vardiya Raporu`}
                                size="small"
                            >
                                <Descriptions.Item label="Rapor Statüsü ">{report.status}</Descriptions.Item>
                                <Descriptions.Item label="Firma Adı ">{report.companyName}</Descriptions.Item>
                                <Descriptions.Item label="Alt Firma Adı">{report.subCompanyName}</Descriptions.Item>
                                <Descriptions.Item label="Vardiya Başlangıc">{report.shiftStartTime}</Descriptions.Item>
                                <Descriptions.Item label="Kurye Başlangıcı ">{report.startTime}</Descriptions.Item>
                                <Descriptions.Item label="Vardiya Bitişi ">{report.shiftEndTime}</Descriptions.Item>
                                <Descriptions.Item label="Kurye Bitişi  ">{report.endTime}</Descriptions.Item>
                                <Descriptions.Item label="Geç Giriş ">{report.lateStart}</Descriptions.Item>
                                <Descriptions.Item label="Erken Çıkış  ">{report.earlyEnd}</Descriptions.Item>
                                <Descriptions.Item label="Başlangıç Statü">{report.startStatus}</Descriptions.Item>
                                <Descriptions.Item label="Bitiş Statü ">{report.endStatus}</Descriptions.Item>
                                <Descriptions.Item label="Çalışılan Saat">{minuteToString(report.workTimeMinute)}</Descriptions.Item>
                                <Descriptions.Item label="Çalışılan Dakika">{report.workTimeMinute}</Descriptions.Item>
                                <Descriptions.Item label="Meşgul Dakika: ">{report.busyTimeMinute}</Descriptions.Item>
                                <Descriptions.Item label="Paket Sayısı">{report.packageCount}</Descriptions.Item>
                                <Descriptions.Item label="Rapor Id">{report._id}</Descriptions.Item>
                            </Descriptions>
                        )}
                    </Card>
                </Col>
                <Col span={24}>
                    <Card bordered={false}>
                        {shifts !== null && shifts.results.map((shift, shiftIndex) =>
                            <Descriptions
                                bordered
                                title={`${shiftIndex + 1}. Vardiya`}
                                size="small"
                            >
                                <Descriptions.Item label="Şehir">  {shift.city}</Descriptions.Item>
                                <Descriptions.Item label="Vardiya Başlangıcı: ">{shift.shiftStartTime}</Descriptions.Item>
                                <Descriptions.Item label="Vardiya Bitiş">{shift.shiftEndTime}</Descriptions.Item>
                                <Descriptions.Item label="Havuz">{shift.isPool ? "Evet" : "Hayır"}</Descriptions.Item>
                                <Descriptions.Item label="Hesaplanmış Paket Sayısı">{shift.calculatedPackageCount}</Descriptions.Item>
                                <Descriptions.Item label="Onaylanmış Paket Sayısı ">{shift.verifiedPackageCount}</Descriptions.Item>
                                <Descriptions.Item label="Vardiya Id ">{shift._id}</Descriptions.Item>
                            </Descriptions>
                        )}
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col span={24} >
                    <Timeline style={{ marginTop: "3em" }} mode="alternate">
                        {courierStatusData !== null && courierStatusData.map((log, cardIndex) =>
                            <Timeline.Item color={courierStatusColors[log.status]} key={cardIndex}>
                                <p>{moment(
                                    new Date(log.createdAt)
                                ).format("L LTS")}</p>
                                <p> {courierStatusData[
                                    cardIndex -
                                    1
                                ] && calculateDuration({
                                    startDate: log.createdAt,
                                    endDate:
                                        courierStatusData[cardIndex - 1].createdAt
                                })}</p>
                                <p>{log.status}</p>
                                <p>{log.reason}</p>
                            </Timeline.Item>
                        )}
                    </Timeline>
                </Col>
            </Row>

        </React.Fragment>
    ));
};
